/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default [
  {
    url: '/dashboard/d',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    
  },
  {
    url: null,
    name: 'Consultas',
    tag: '',
    tagColor: 'warning',
    icon: 'CalendarIcon',
    i18n: 'Consultations',
    submenu: [
      // {
      //   url: '/consultations/newConsultation',
      //   name: 'Nueva Consulta',
      //   slug: 'dashboard-analytics',
      //   i18n: 'NewConsultation'
      // },
      {
        url: '/consultations/upcommingAppointments',
        name: 'Próximas Citas',
        slug: 'dashboard-ecommerce',
        i18n: 'UpcommingAppointments'
      },
      {
        url: '/consultations/calendar',
        name: 'Calendario',
        slug: 'dashboard-ecommerce',
        i18n: 'Calendar'
      },
      {
        url: '/consultations/history',
        name: 'Historial',
        slug: 'dashboard-ecommerce',
        i18n: 'history'
      }
    ]
  },
  {
    url: '/patients/list',
    name: 'Pacientes',
    tag: '',
    tagColor: 'warning',
    icon: 'UsersIcon',
    slug: 'dashboard-ecommerce',
    i18n: 'Patients'
  },
  {
    url: null,
    name: 'RecetasExámenes',
    icon: 'BookIcon',
    i18n: 'RecipesExams',
    submenu: [
      {
        url: '/recipes/list',
        name: 'Recetas',
        slug: 'dashboard-ecommerce',
        i18n: 'Recipes',
      },
      {
        url: '/recipes/exams',
        name: 'Examenes',
        slug: 'dashboard-ecommerce',
        i18n: 'Exams'
      }
    ]
  },
  {
    url: '/reports',
    name: 'Reportes',
    icon: 'BarChartIcon',
    slug: 'extra-component-maps-google-map',
    i18n: 'reports'
  },
  {
    url: '/box',
    name: 'Caja',
    icon: 'DollarSignIcon',
    slug: 'extra-component-maps-google-map',
    i18n: 'box'
  },
  {
    url: '/profile/myAccount',
    name: 'Perfil',
    icon: 'UserIcon',
    slug: 'dashboard-analytics',
    i18n: 'MyAccount'
  },
  {
    header: 'Soporte',
    icon: '',
    i18n: 'Support',
    items: [
      {
        url: '/support/documentation',
        name: 'Documentación',
        icon: 'FolderIcon',
        slug: 'extra-component-maps-google-map',
        i18n: 'Documentation'
      },
      {
        url: '/support/raise',
        name: 'Solicitar Soporte',
        icon: 'LifeBuoyIcon',
        slug: 'extra-component-maps-google-map',
        i18n: 'RaiseSupport'
      }
    ]
  }
]

